import { Box, IconButton, Typography } from "@mui/material";
import { ChevronLeft, Upload } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useResponsiveStyles } from "../../styles/useResponsiveStyles";

const CommonNavigator = ({
    title,
    showBackButton = false,
    showExportToExcel = false,
    triggerExportToExcel = () => {},
    startDate,
    endDate,
}) => {
    const navigate = useNavigate();
    const { getFontSize } = useResponsiveStyles();

    const goBack = () => {
        navigate(-1);
    };
    return (
        <div className="flex justify-between items-center">
            <div className="flex items-center gap-2">
                {showBackButton && (
                    <Box>
                        <IconButton
                            onClick={goBack}
                            size="small"
                            sx={{
                                backgroundColor: "white",
                                borderRadius: 1,
                                px: 0.2,
                                py: 0.4,
                            }}
                        >
                            <ChevronLeft size={18} />
                        </IconButton>
                    </Box>
                )}

                <Box className="flex items-end">
                    <h1
                        className="font-bold text-primary leading-none"
                        style={{ ...getFontSize("heading") }}
                    >
                        {title}
                    </h1>
                    {startDate && endDate && (
                        <span className="text-gray-500 text-[11px] ml-2 mb-[1px] leading-none">
                            Displaying data from ({startDate}) to ({endDate})
                        </span>
                    )}
                </Box>
            </div>
            <div className="flex items-center gap-4"  >
                {showExportToExcel && (
                    <div className="flex gap-2" style={{cursor: 'pointer'}} onClick={() => triggerExportToExcel()}>
                        <Upload className="text-primary" size={15}/>
                        <Typography className="text-primary" sx={{fontSize: 12}}>
                            Export to Excel
                        </Typography>
                    </div>
                )}
            </div>
        </div>
    );
};

// Memoize the component before exporting
export default React.memo(CommonNavigator);
